<script>
import resources from './resources'

export default {
  name: 'professional-prices-form',
  mixins: [resources]
}
</script>

<template lang="pug">
page(title="Honorário por Estabelecimento e Localidade", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Honorário Médico incluido com sucesso.',
          :buttonsNext='nextStepButtonPrices',
          v-if="wasRaised && !userIsCompany")

        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Honorário Médico alterado com sucesso.',
          :buttonsNext='nextStepButtonPrices',
          v-if="beenUpdated && !userIsCompany")

        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Honorário Médico incluido com sucesso.',
          :buttonsNext='nextStepButtonPricesCompany',
          v-if="wasRaised && userIsCompany")

        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Honorário Médico alterado com sucesso.',
          :buttonsNext='nextStepButtonPricesCompany',
          v-if="beenUpdated && userIsCompany")

        ul.nav.nav-tabs
          li
            router-link(:to="{name: 'professional.company.prices.index'}")
              a(href="#") Listagem
          li.active
            a(href='#') Cadastro
        .col-xs-12.white-bg
          .row
            .col-xs-12
              .space
              .row(v-if="userIsCompany")
                .col-sm-12
                  .form-group
                    f-select-company-staff-professional(label="Profissional",
                     name="professional_id",
                     v-model="price.professional_id",
                     :searchable="true",
                     :get-all="true",
                     @selected="setProfessional",
                     :errors="errors['professional_id']")
              .row
                .col-sm-6
                  .form-group
                    v-input(:status="$v.price.company_address_id.$error ? 'error' : null")
                      f-select-company-address(label="Local de Atendimento",
                         name="company_address_id",
                         v-model="price.company_address_id",
                         :get-all="true",
                         :searchable="true",
                         :errors="errors['company_address_id']")

                .col-sm-2
                  v-input(:status="$v.price.kind.$error ? 'error' : null")
                    f-select(label="Tipo de Honorário",
                      name="kind",
                      v-model="price.kind",
                      :options="kindOptions",
                      :searchable="true",
                      :errors="errors['kind']")

                .col-sm-2
                  v-input(:status="$v.price.validity.$error ? 'error' : null")
                    label Início da vigência
                    .input-group
                      v-datepicker(
                        v-model='price.validity',
                        @change="changeValidity(price.validity)"
                        :config='config')

                .col-sm-2
                  v-input(:status="$v.price.value.$error ? 'error' : null")
                    f-numeric(
                      label="Particular",
                       currency='R$',
                       separator="."
                       :precision="2",
                       v-model='price.value')

              .row
                h4.p-l-15 PREVISÃO DE RECEBIMENTO POR CONVÊNIO
                div.col-sm-6(v-for="(covenant, index) in covenants", :key="covenant.id")
                  f-numeric(
                    :label="covenant.name",
                    currency='R$',
                    separator="."
                    :precision="2",
                    v-model='covenant.value',
                    :errors="errors['covenants.' + index + '.value']")

              .buttons-wrapper
                button.btn.save(@click.prevent="doSave()", v-if="!saved")
                  span.icon 
                  |  Salvar Honorário
                button.btn.find-filled(@click.prevent="newPrice()", v-if="price.id")
                  span.icon 
                  |  Nova vigência
</template>
<style scoped>
  .p-l-15 {
    padding-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/app/professional/company/prices/form/form.vue